/**
 * @flow
 * @relayHash 11cbfcff985c417a0803a62d8db939df
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PlannerPlaylistContainer_node$ref = any;
export type RemovePlannerPlaylistRecommendationInput = {
  clientMutationId?: ?string,
  planner_playlist_id: string,
  playlist_id: string,
};
export type PlannerPlaylist_removePlannerPlaylistRecommendationMutationVariables = {|
  input: RemovePlannerPlaylistRecommendationInput
|};
export type PlannerPlaylist_removePlannerPlaylistRecommendationMutationResponse = {|
  +removePlannerPlaylistRecommendation: ?{|
    +planner_playlist: ?{|
      +$fragmentRefs: PlannerPlaylistContainer_node$ref
    |}
  |}
|};
export type PlannerPlaylist_removePlannerPlaylistRecommendationMutation = {|
  variables: PlannerPlaylist_removePlannerPlaylistRecommendationMutationVariables,
  response: PlannerPlaylist_removePlannerPlaylistRecommendationMutationResponse,
|};
*/


/*
mutation PlannerPlaylist_removePlannerPlaylistRecommendationMutation(
  $input: RemovePlannerPlaylistRecommendationInput!
) {
  removePlannerPlaylistRecommendation(input: $input) {
    planner_playlist {
      ...PlannerPlaylistContainer_node
      id
    }
  }
}

fragment PlannerPlaylistContainer_node on PlannerPlaylist {
  id
  title
  description
  max_length
  position
  num_songs
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_recommendations {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
      }
    }
  }
  playlist_songs: planner_playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  music_planner {
    id
    can_edit
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RemovePlannerPlaylistRecommendationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "RemovePlannerPlaylistRecommendationInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "num_songs",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "width",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "height",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    v7,
    v8,
    v9,
    v3
  ]
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isrc",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "album",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "artist",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "song_images",
  "storageKey": null,
  "args": null,
  "concreteType": "SongImageConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "SongImage",
          "plural": false,
          "selections": [
            v3,
            v7,
            v8,
            v9
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PlannerPlaylist_removePlannerPlaylistRecommendationMutation",
  "id": null,
  "text": "mutation PlannerPlaylist_removePlannerPlaylistRecommendationMutation(\n  $input: RemovePlannerPlaylistRecommendationInput!\n) {\n  removePlannerPlaylistRecommendation(input: $input) {\n    planner_playlist {\n      ...PlannerPlaylistContainer_node\n      id\n    }\n  }\n}\n\nfragment PlannerPlaylistContainer_node on PlannerPlaylist {\n  id\n  title\n  description\n  max_length\n  position\n  num_songs\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_recommendations {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n      }\n    }\n  }\n  playlist_songs: planner_playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  music_planner {\n    id\n    can_edit\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PlannerPlaylist_removePlannerPlaylistRecommendationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "removePlannerPlaylistRecommendation",
        "storageKey": null,
        "args": v1,
        "concreteType": "RemovePlannerPlaylistRecommendationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "planner_playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylist",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PlannerPlaylistContainer_node",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PlannerPlaylist_removePlannerPlaylistRecommendationMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "removePlannerPlaylistRecommendation",
        "storageKey": null,
        "args": v1,
        "concreteType": "RemovePlannerPlaylistRecommendationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "planner_playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylist",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "max_length",
                "args": null,
                "storageKey": null
              },
              v5,
              v6,
              v10,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "playlist_recommendations",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlaylistEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Playlist",
                        "plural": false,
                        "selections": [
                          v3,
                          v6,
                          v4,
                          v10,
                          v2
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "playlist_songs",
                "name": "planner_playlist_songs",
                "storageKey": "planner_playlist_songs(first:99999)",
                "args": v11,
                "concreteType": "PlannerPlaylistSongConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlannerPlaylistSongEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PlannerPlaylistSong",
                        "plural": false,
                        "selections": [
                          v3,
                          v5,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "song",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              v12,
                              v3,
                              v13,
                              v14,
                              v15,
                              v16,
                              v17
                            ]
                          },
                          v12
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": "playlist_songs",
                "name": "planner_playlist_songs",
                "args": v11,
                "handle": "connection",
                "key": "MusicPlannerContainer_planner_playlist_songs",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "music_planner",
                "storageKey": null,
                "args": null,
                "concreteType": "MusicPlanner",
                "plural": false,
                "selections": [
                  v3,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "can_edit",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "song_search",
                "storageKey": "song_search(first:10,query:\"\")",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "query",
                    "value": "",
                    "type": "String!"
                  }
                ],
                "concreteType": "SongConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SongEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          v12,
                          v3,
                          v14,
                          v15,
                          v16,
                          v13,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "duration_ms",
                            "args": null,
                            "storageKey": null
                          },
                          v17,
                          {
                            "kind": "InlineFragment",
                            "type": "SpotifySong",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_id",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_source",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_data",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c6dc96cd315da8a2e0135bbf433e7486';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/MusicPlanner/__generated__/PlannerPlaylist_removePlannerPlaylistRecommendationMutation.graphql.js